import useXFetch from '~/composables/useXFetch'
import { PP_DRIVE_API } from './common'

export const LINK_HUB_API_V1 = `${PP_DRIVE_API}/linkhub/v1`

export interface LinkItem {
  link: string
  title: string
  icon: string
  description: string
  published_times: number
  collected_times: number
  created_at: string
  updated_at: string
  publishers: Array<{
    user_name: string
    avatar: string
    folder: string
  }>
}

export interface LinkHub {
  error?: string
  error_description?: string
  count?: number
  links?: LinkItem[]
}

// 获取链接列表
export const getLinkHubList = async () =>
  useXFetch<LinkHub>(`${LINK_HUB_API_V1}/list`, {
    method: 'get',
    withCredentials: true,
  })

export const getUserSetting = (items: string[]) => {
  const params = items.map(i => `items=${i}`).join('&')
  return useXFetch<{ settings: Record<string, string> }>(`${PP_DRIVE_API}/user/v1/settings?${params}`, {
    method: 'GET',
    withCredentials: true,
  })
}

export const setUserSetting = (item: string, value: string) =>
  useXFetch(`${PP_DRIVE_API}/user/v1/settings`, {
    method: 'POST',
    body: {
      item,
      value,
    },
    withCredentials: true,
  })

export const plusCollects = (link: string, folder: string) =>
  useXFetch<{
    link: LinkItem
  }>(`${LINK_HUB_API_V1}/collect`, {
    method: 'POST',
    body: {
      link,
      folder,
    },
    withCredentials: true,
  })
